import { Box, Text } from "@chakra-ui/react";
import { Card } from "../../../../../components/Card";
import { LegendlessDonutChart } from "../../../../../components";
import * as React from "react";

function ScopeThreeCategoriesDonutChart({ data }) {
  const getTooltip = (tooltipObj) => {
    const { datum: { data } } = tooltipObj;
    const formattedValue = data.value && data.value > 0 ?
      data.value.toLocaleString("en-GB", { maximumFractionDigits: 4 }) : "";

    return (
      <Box position="relative">
        <Card
          position="absolute"
          minWidth={"250px"}
          padding={3}
          right={"100%"}
        >
          <Text fontSize="sm">
            Category {data.index}: {data.label} - <b>{formattedValue}</b> tCO<sub>2e</sub>
          </Text>
        </Card>
      </Box>);
  };

  return (
    <LegendlessDonutChart
      data={data}
      getTooltip={getTooltip}
      getLabel={(el) => {
        return el.data.value && el.data.value > 0 ?
          el.data.value.toLocaleString("en-GB", { maximumFractionDigits: 4 }) : "";
      }}
      getLabelsTextColor={(el) => {
        const darkBackgrounds = [1, 2, 3, 4, 5, 6, 7, 13];
        return darkBackgrounds.includes(el.data.index) ? "white" : "black";
      }}
    />
  );
}

export default ScopeThreeCategoriesDonutChart;